import { combineReducers } from 'redux';

import { contentReducer, initialContentState }             from './contentReducer';
import { contentChangeReducer, initialChangeContentState } from './contentChangeReducer';
import { componentsReducer, initialComponentsState }       from './componentsReducer';
import { dataReducer, initialDataState }                   from './dataReducer';
import { modalReducer, initialModalState }                 from './modalReducer';
import { pageReducer, initialPageState }                   from './pageReducer';
import { menusReducer, initialMenusState }                 from './menusReducer';
import { manualNavReducer, initialNavState }               from './manualNavReducer';
import { lrsReducer, initialLrsState }                     from './lrsReducer';
import { sizeReducer, initialSizeState }                   from './sizeReducer';
import { sessionReducer, initialSessionState }             from './sessionReducer';
import { idleTimeReducer, initialIdleTimeState }           from './idleTimeReducer';

/* ✅ default + named export from authReducer */
import authReducer, { initialAuthState }                   from './authReducer';

const reducer = combineReducers({
  data:          dataReducer,
  content:       contentReducer,
  contentChange: contentChangeReducer,
  components:    componentsReducer,
  modal:         modalReducer,
  page:          pageReducer,
  menus:         menusReducer,
  manualNav:     manualNavReducer,
  lrs:           lrsReducer,
  size:          sizeReducer,
  session:       sessionReducer,
  idleTime:      idleTimeReducer,
  auth:          authReducer,               // ← token support
});

export const initialState = {
  data:          initialDataState,
  content:       initialContentState,
  contentChange: initialChangeContentState,
  components:    initialComponentsState,
  modal:         initialModalState,
  page:          initialPageState,
  menus:         initialMenusState,
  manualNav:     initialNavState,
  lrs:           initialLrsState,
  size:          initialSizeState,
  session:       initialSessionState,
  idleTime:      initialIdleTimeState,
  auth:          initialAuthState,          // ← token support
};

export type reducerType = ReturnType<typeof reducer>;

export { reducer };
export default reducer;
